import React from 'react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';

export const bindOnRenderHeader = (column) => {
  if (column.onRenderHeader) {
    return column;
  }

  const onRenderHeader = columnProps => (
    <div>
      <span className="grid-header-text">
        {columnProps.column.name}
      </span>
      {columnProps.column.helpTopic && <HelpIcon topic={columnProps.column.helpTopic} />}
    </div>
  );

  return {
    ...column,
    onRenderHeader,
  };
};
